export const sortCategories = [
    { name: 'All', id: 'all', arrow: false, asc: true },
    { name: 'Title', id: 'title', arrow: false, asc: true },
    { name: 'Published', id: 'published', arrow: false, asc: true },
    { name: 'Unpublished', id: 'unpublished', arrow: false, asc: true },
    { name: 'Unpublished updated', id: 'unpublishUpdated', arrow: false, asc: true },
    { name: 'Pending', id: 'pending', arrow: false, asc: true },
    { name: 'Rejected', id: 'rejected', arrow: false, asc: true },
    { name: 'Published updated', id: 'publishUpdated', arrow: false, asc: true },
    { name: 'Refreshed', id: 'refresh', arrow: false, asc: true },
    { name: 'Pending rejected', id: 'pendingRejected', arrow: false, asc: true },
    { name: 'Premium jobs', id: 'premium', arrow: false, asc: true },
    { name: 'Premium Pending jobs', id: 'premium-pending', arrow: false, asc: true },
    { name: 'Job Universe Jobs', id: 'jobUniverse', arrow: false, asc: true },
    { name: 'CS/Sales Mail Sent Jobs', id: 'preRejectJobs', arrow: false, asc: true },
]